var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"l-breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'projects' }}},[_vm._v("\n      サイト一覧\n    ")])],1),_vm._l((_vm.list),function(item){return _c('li',{key:item.name},[_c('router-link',{attrs:{"to":item.to}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }